import { ProgressBar } from "primereact/progressbar";
import { Props } from "./types";

export function SyncProgressSection({ progress, loading, currentTip }: Props) {
  return (
    <div className="flex flex-column gap-2">
      <ProgressBar value={progress} showValue />
      {loading && (
        <small className="text-600 text-center font-italic">{currentTip}</small>
      )}
    </div>
  );
}
